import twMerge from "../../../../lib/twMerge";

export default function ConfigItem({
  className,
  children,
}: {
  className?: string;
  children: React.ReactNode;
}): React.ReactElement | null {
  return (
    <div
      className={twMerge(
        "border-base-grey-medium flex flex-row items-center gap-1 rounded-[8px] border p-[4px]",
        className
      )}
    >
      {children}
    </div>
  );
}
